import { map } from "lodash";
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { locationResource } from 'utils/assets/images';

const Index = ({ Items, onClick }) => {
    return (
        <div>
            <div className="learnWay">
                <img src={locationResource} />
                <Link>How to Videos with one way</Link>
            </div>
            {/* <div className="listSrch"><Link><Button>search</Button></Link></div> */}
            <div className="learnListingUpr learnListingUprBlog">
                <ul className="learnListing">
                    {map(Items, itm => (
                        <li><Link onClick={() => onClick(itm)}>{itm.title}</Link></li>
                    ))}
                </ul>
            </div>
        </div>
    );
};


//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = state => ({});
export default connect(mapStateToProps, null)(Index);
